import React from "react";
import { createActionPlanTopic, getActionPlanSurveyTopics, updateActionPlanTopicData } from "../../../api/actionPlanClientApi";
import { Button } from "../../../designSystem/button/Button";
import { rng, SurveyTopic } from '../../../amorg-common';
import { ButtonRow } from "../../../designSystem/button/ButtonRow";
import { CloseModalButton } from "../../../designSystem/compositeComponents/CloseModalButton";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { ListRow } from "../../../designSystem/compositeComponents/ListRow";
import { LoadingPageOverlay } from "../../../designSystem/LoadingPageOverlay";
import { Modal } from "../../../designSystem/Modal";
import { Tabber } from "../../../designSystem/Tabber";
import { SurveyTopicInfoPanel } from "./SurveyTopicInfoPanel";



type SurveyTopicListButtonProps = {
    actionPlanId:string,
    onUpdated: () => void
}
export function SurveyTopicListButton (props: SurveyTopicListButtonProps): JSX.Element
{
    const [surveyTopics, setSurveyTopics] = React.useState<SurveyTopic[]>([]);
    const [showSurveyTopics, setShowSurveyTopics] = React.useState(false);
    const [loading, setLoading] = React.useState(false);

    // React.useEffect(() =>
    // {
    //     async function loadSurveyTopics()
    //     {
    //         setLoading(true);
    //         setSurveyTopics(await getActionPlanSurveyTopics(props.actionPlanId));
    //         setLoading(false);
    //     }
    //     loadSurveyTopics();
    // }, [props.actionPlanId]);

    async function handleClickShowModal()
    {
        setLoading(true);
        setSurveyTopics(await getActionPlanSurveyTopics(props.actionPlanId));
        setLoading(false);
        setShowSurveyTopics(true);
    }

    async function handleClickCreateSurveyTopic (st: SurveyTopic)
        {
            const topicId = rng.getRandomId();
            setLoading(true);
            if ((await createActionPlanTopic(topicId, props.actionPlanId)).isSuccess)
            {
                if (((await updateActionPlanTopicData(topicId, { type: 'WPA', customData: { surveyTopicIdentifier: st } })).isSuccess))
                {
                    setShowSurveyTopics(false);
                    props.onUpdated();
                }
            }
            setLoading(false);
        }

    return (
        <>
            <LoadingPageOverlay loading={loading} />
            
            <ButtonRow variant='stretched'>
                <Button
                    variant="light"
                    size={"42px"}
                    onClick={handleClickShowModal}
                    text={"Vælg emne fra rapporten"}
                    // disabled={surveyTopics.length === 0} 
                />
            </ButtonRow>
        
            {surveyTopics.length > 0 &&
                <Modal
                    title={"Emner fra spørgeskemaet"}
                    width={'60%'}
                    content={
                        <Flex flexDirection='column' gap={16}>
                            <ActionPlanSurveyTopicList
                                topics={surveyTopics}
                                onClickCreateTopic={handleClickCreateSurveyTopic} />
                            <CloseModalButton onClose={() => setShowSurveyTopics(false)} />
                        </Flex>
                    }
                    showModal={showSurveyTopics}
                    onCancel={() => setShowSurveyTopics(false)}
                />
            }
        </>
    );
}

type ActionPlanSurveyTopicListProps = {
    topics: SurveyTopic[],
    onClickCreateTopic: (st: SurveyTopic) => void
}
type TopicMode = 'theme' | 'indicator' | 'question'

function ActionPlanSurveyTopicList(props: ActionPlanSurveyTopicListProps): JSX.Element {
    const [mode, setMode] = React.useState<TopicMode>('theme');

    const selectedTopics = props.topics.filter(t => t.linkType === mode)
        .sort((a, b) => a.data.title.localeCompare(b.data.title));

    return (
        <>
            <div style={{margin:'10px'}}>
                <Tabber items={[
                        {tabName:'question', text:'Spørgsmål'},
                        {tabName:'theme', text:'Temaer'},
                        {tabName:'indicator', text:'Indikatorer'}
                    ]}
                    selectedTabName={mode}
                    onClick={(tabName) => setMode(tabName as TopicMode)} 
                />
            </div>
            <Flex flexDirection="column" gap={16} style={{height:'60vh', overflowY:'scroll'}}>
                {selectedTopics.map((st, index) => {

                    return (
                        <ListRow key={index} styleVariant="neutral">
                            <Flex flexDirection="column" gap={8} style={{padding:'8px'}}>
                                <SurveyTopicInfoPanel surveyTopic={st} />
                                    
                                <Button variant="outlined"
                                    size="32px"
                                    onClick={() => props.onClickCreateTopic(st)}
                                    icon="actions_plus"
                                    text="Vælg" />
                            </Flex>
                        </ListRow>
                    );
                })}
            </Flex>
        </>
    );
}